/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DocumentFileUpdate = {
  status: string;
};

/** @internal */
export const DocumentFileUpdate$inboundSchema: z.ZodType<
  DocumentFileUpdate,
  z.ZodTypeDef,
  unknown
> = z.object({
  status: z.string(),
});
/** @internal */
export type DocumentFileUpdate$Outbound = {
  status: string;
};

/** @internal */
export const DocumentFileUpdate$outboundSchema: z.ZodType<
  DocumentFileUpdate$Outbound,
  z.ZodTypeDef,
  DocumentFileUpdate
> = z.object({
  status: z.string(),
});

export function documentFileUpdateToJSON(
  documentFileUpdate: DocumentFileUpdate,
): string {
  return JSON.stringify(
    DocumentFileUpdate$outboundSchema.parse(documentFileUpdate),
  );
}
export function documentFileUpdateFromJSON(
  jsonString: string,
): SafeParseResult<DocumentFileUpdate, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DocumentFileUpdate$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DocumentFileUpdate' from JSON`,
  );
}
